'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/**
 * The preceding flow comment must remain first in this file so that it is detected as supporting Flow. This is necessary
 * so that required files can also support Flow and it will pass through properly when imported into a web project.
 */

var _newAnalyticsExports = require('./newAnalyticsExports');

var _newAnalyticsExports2 = _interopRequireDefault(_newAnalyticsExports);

var _GoogleTagManagerProvider = require('./GoogleTagManagerProvider');

var _GoogleTagManagerProvider2 = _interopRequireDefault(_GoogleTagManagerProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocalyticsProvider = require('./LocalyticsProvider');
var GoogleProvider = require('./GoogleProvider');
var GoogleMeasurementProtocolProvider = require('./GoogleMeasurementProtocolProvider');
var Helper = require('./Helper');

var ProviderTypes = {
    GOOGLE: 0,
    LOCALYTICS: 1,
    GOOGLE_MEASUREMENT_PROTOCOL: 2,
    GOOGLE_TAG_MANAGER: 3
};

var AnalyticsFactory = {
    /**
     * Creates an analytics by type
     * @param {AnalyticsType} ProviderTypes
     * @param options
     */
    create: function create(analyticsType, options) {
        return new AnalyticsProviders[analyticsType](options);
    }
};

var AnalyticsProviders = [GoogleProvider, LocalyticsProvider, GoogleMeasurementProtocolProvider,

// REMOVE after all dependent sites are updated to utilize the latest refactor - here for backwards compatibility
_GoogleTagManagerProvider2.default];

module.exports = _extends({
    Factory: AnalyticsFactory,
    ProviderTypes: ProviderTypes,
    Helper: Helper

}, _newAnalyticsExports2.default);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/Analytics.js
// module id = 850
// module chunks = 0